import { Component, OnDestroy, OnInit } from '@angular/core';
import { SyncService } from '../../services/sync.service';
import { Subscription } from 'rxjs/Rx';
import { Router } from '@angular/router';
import { environment } from '../../../environments/environment';

@Component({
	selector: 'app-sync',
	templateUrl: './sync.component.html',
	styleUrls: ['./sync.component.scss']
})

/**
 * (c) it.x informationssysteme gmbh, Alle Rechte vorbehalten.
 *
 * Sync Component.
 */
export class SyncComponent implements OnInit, OnDestroy
{
	/**
	 * Environment.
	 */
	public environment = environment;

	/**
	 * Progress percentage.
	 */
	private percentage: number;

	/**
	 * Task description.
	 */
	public text: string;

	/**
	 * Sync status.
	 */
	public status: string;

	/**
	 * Subscripton for the current progress (percentage).
	 */
	private percentageSubscription: Subscription;

	/**
	 * Subscripton for the current task.
	 */
	private taskSubscription: Subscription;

	/**
	 * Subscripton for the sync status.
	 */
	private statusSubscription: Subscription;

	/**
	 * Constructor.
	 */
	public constructor(
		private syncService: SyncService,
		private router: Router
	)
	{}

	/**
	 * Lifecycle-Hook: OnInit.
	 */
	public ngOnInit()
	{
		this.percentageSubscription = this.syncService.currentPercentage.subscribe(percentage => this.percentage = percentage);
		this.taskSubscription = this.syncService.currentTask.subscribe(text => this.text = text);
		this.statusSubscription = this.syncService.status.subscribe(status => {
			this.status = status;

			// Redirect on success.
			if (this.status === 'success')
			{
				this.redirect();
			}
		});

		this.syncService.startSync();
	}

	/**
	 * Lifecycle-Hook: OnDestroy.
	 */
	public ngOnDestroy()
	{
		this.percentageSubscription.unsubscribe();
		this.taskSubscription.unsubscribe();
		this.statusSubscription.unsubscribe();
	}

	/**
	 * Return the style for the progress bar.
	 */
	public getStyle()
	{
		return {
			'width': this.percentage + '%'
		};
	}

	/**
	 * Eventhandler: Back to stage (Success).
	 */
	public onBackToStage()
	{
		this.router.navigateByUrl('/portal/stage');
	}

	/**
	 * Redirects to a specific route, depending on sync status.
	 */
	private redirect()
	{
		this.router.navigateByUrl('/portal/stage');
	}
}



// WEBPACK FOOTER //
// /var/data/workspace/hess/hess_smart_city_web/src/app/components/sync/sync.component.ts